import { PaginatorResponse } from "src/app/modules/utils/model/pages-and-components.config";
import { DocumentType } from "../../accounts-receivable/model/documentType.model";

export class CallManagement{
    id : string;
    status : string;
    communicationId : string;
    parentCallManagementId : string;
    clientId : string;
    projectId : string;
    registerDate : string | Date | null;
    callDate : string | Date | null;
    assignedBoUserId : string;
    lastActionType : string;
    lastActionDate : string | Date | null;
    actions : CallManagementAction[];
    phoneNumber : string | null;
    paymentOrderReference: PaymentOrderReference[];
    isIncomingCall?: boolean;
    /**
     * true cuando el backend origina la llamada en la central (click-2-call: se
     * envió `provider` a POST /callmanagement/manual). En ese caso Asterisk
     * llama a la extensión del agente y el webphone debe CONTESTAR, no marcar.
     *
     * Si es false/undefined el backend solo registra la gestión y el webphone
     * es quien marca (flujo de Gestión de llamadas, PATCH /callmanagement/action).
     *
     * Marcar en ambos lados producía dos llamadas al mismo destino (GS-7027).
     */
    originatedByBackend?: boolean;
}

export class PaymentOrderReference{
    paymentOrderId: string;
    reference: string;
}

export class CallManagementPageableData extends PaginatorResponse {
    content: CallManagementCustom[];
}

export class CallManagementCustom extends CallManagement {
    clientId : string;
    countryCode : string;
    documentTypeId : number;
    documentNumber : string;
    name : string;
    lastName : string;
    cellphone1 : string;
    selectedCellPhone1:boolean;
    cellphone2 : string;
    selectedCellPhone2:boolean;
    cellphone3 : string;
    cellphone4 : string;
    cellphone5 : string;
    email1 : string;
    email2 : string;
    externalClientId : string;
    documentType? : DocumentType;
    paymentOrderDueDate : string | Date | null;
    daysLate? : number | null;
    assignedBoUser: string;
    disabledButtonCall:boolean;
    balance : CallManagementBalance[];
    balanceAsString? : string | null;
    phoneNumber : string | null;
}

export class CallManagementAction{
    actionType : string;
    actionDate : string | Date | null;
    phoneNumber : string;
    boUserId : string;
    communicationId: string;
}

export class CallManagementBalance{
    currency : string;
    balance : string;
}

export enum CallManagementActionType {
    ASSIGN_USER_ACTION_TYPE = "assignUser",
    PAYMENT_IN_REVIEW_OR_COMMITMENT_ACTION_TYPE = "paymentInReviewOrCommitment",
    PAYMENT_COMMITMENT_ACTION_TYPE = "paymentCommitment",
    PAYMENT_IN_REVIEW_ACTION_TYPE = "paymentInReview",
    RETRY_CALL_ACTION_TYPE = "retryCall",
    INBOUND_RETRY_CALL_ACTION_TYPE = "inboundRetryCall",
    REFUSE_TO_PAY_ACTION_TYPE = "refuseToPay",
    CANT_PAY_ACTION_TYPE = "cantPay",
    WRONG_PHONE_NUMBER_ACTION_TYPE = "wrongPhoneNumber",
    NO_RESPONSE_ACTION_TYPE = "noResponse",
    NO_CONTACTED_ACTION_TYPE = "noContacted",
    CALL_ACTION_TYPE = "call",
    PAYMENT_RENEGOTIATION_TYPE = "paymentRenegotiation",
    MESSAGE_IN_MAILBOX_TYPE = "messageInMailbox",
    CONTACT_WITH_THIRD_PARTY_TYPE = "contactWithThirdParty",
    INBOUND_PAYMENT_IN_REVIEW_OR_COMMITMENT_ACTION_TYPE = "inboundPaymentInReviewOrCommitment",
    INBOUND_PAYMENT_RENEGOTIATION_TYPE = "inboundPaymentRenegotiation",
    INBOUND_REQUESTED_INFORMATION_TYPE = "inboundRequestedInformation",
    INBOUND_CLAIM_TYPE = "inboundClaim",
    REFINANCE_TYPE = "refinance",
    INBOUND_REFINANCE_TYPE = "inboundRefinance",
    INBOUND_PAYMENT_COMMITMENT_ACTION_TYPE = "inboundPaymentCommitment",
    INBOUND_PAYMENT_IN_REVIEW_ACTION_TYPE = "inboundPaymentInReview",
    PAYMENT_MADE_TYPE = "paymentMade",
    INBOUND_PAYMENT_MADE_TYPE = "inboundPaymentMade",
    IN_PROCESS_TYPE = "inProcess",
    COMMUNICATION_REMINDER_TYPE = "communicationReminder",
    PAUSED_COMMUNICATION_CONTACT_ACTION_TYPE  = "pausedCommunicationContact",
    PAUSED_COMMUNICATION_NO_CONTACT_ACTION_TYPE = "pausedCommunicationNoContact",
    PAUSED_COMMUNICATION_INBOUND_ACTION_TYPE = "pausedCommunicationInbound",
    CALL_SENT_TO_PROVIDER_ACTION_TYPE = "callSentToProvider",
    INBOUND_CONTACT_HUNG_UP_ACTION_TYPE = "inboundContactHungUp",
    CONTACT_HUNG_UP_ACTION_TYPE = "contactHungUp",
    CALL_SCHEDULED_ACTION_TYPE = 'callScheduled',
    NO_CONVERSATION_ACTION_TYPE = 'noConversation',
}
